import React from 'react'
import { useSelector } from 'react-redux'
import { FormItem, FormItemTypes } from 'rds'
import CheckoutFormSection from './CheckoutFormSection'
import CheckoutFormOptionLabel from './CheckoutFormOptionLabel'
import DeliverFormAddressSelector from './CheckoutFormAddressSelector'

const CheckoutFormShipmentMethod = ({
    checkout,
    onAddressChange,
    onShipmentMethodChange,
    shipmentMethod,
    showAddressForm,
}) => {
    const locations = useSelector(state => state.location.locations)
    const selectedLocationId = useSelector(
        state => state.location.selectedLocationId,
    )
    const [shipmentMethodOptions, setShipmentMethodOptions] = React.useState([])
    const selectedLocation = locations.find(
        location => location.id === selectedLocationId,
    )
    const doesSelectedLocationAcceptShipments =
        !!selectedLocation?.shipmentCosts.length

    React.useEffect(() => {
        const newShipmentMethodOptions = [
            {
                id: 'take-away',
                label: (
                    <CheckoutFormOptionLabel
                        icon='Application'
                        label='Retiro en local'
                    />
                ),
                description: 'Retiras en la dirección del local seleccionado',
            },
        ]
        if (doesSelectedLocationAcceptShipments) {
            newShipmentMethodOptions.push({
                id: 'deliver',
                label: (
                    <CheckoutFormOptionLabel
                        icon='Home'
                        label='Envío a domicilio'
                    />
                ),
                description:
                    'Enviaremos tu compra a la dirección que especifiques',
            })
        }
        setShipmentMethodOptions(newShipmentMethodOptions)
    }, [doesSelectedLocationAcceptShipments])

    const handleDeliverTypeChange = event => {
        const { value } = event.target
        onShipmentMethodChange(value)
        if (value !== 'deliver') {
            // If it's pickup, erase any shipment state
            onAddressChange('street', '')
            onAddressChange('doorNumber', '')
        }
    }

    const handleAddressChange = (key, value) => {
        // Prevent unnecesary updates
        if (checkout[key] !== value) {
            onAddressChange(key, value)
        }
    }

    return (
        <CheckoutFormSection title='Método de entrega'>
            <FormItem
                type={FormItemTypes.CARD_SELECT}
                values={shipmentMethodOptions}
                value={shipmentMethod}
                onChange={handleDeliverTypeChange}
            />
            {showAddressForm ? (
                <DeliverFormAddressSelector onChange={handleAddressChange} />
            ) : null}
        </CheckoutFormSection>
    )
}

export default CheckoutFormShipmentMethod
